import { faEllipsisVertical } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import styled from "styled-components";
import { dateFormatter } from "../../../../utils/functions";

function TenantTable(props) {
  return (
    <Table>
      <Thead>
        <Tr className="tr-head">
          <Th className="th-cell-1 color-grey">Tenant Id</Th>
          <Th className="th-cell-2 color-grey">Ragione Sociale</Th>
          <Th className="th-cell-3 color-grey"> Partita Iva</Th>
          <Th className="th-cell-4 color-grey">Data Attivazione</Th>
          <Th className="th-cell-5 color-grey">Stato</Th>
          <Th className="th-cell-7 color-grey"></Th>
        </Tr>
      </Thead>

      {!props.isLoading && props.tenantList.length > 0 && (
        <Tbody>
          {props.tenantList?.length > 0 &&
            !props.isLoading &&
            !props.requestError &&
            props.tenantList?.map((tenant, index) => {
              return (
                <Tr className={"tr-body"} key={index}>
                  <Td>{tenant?.teamsystemTenantId}</Td>
                  <Td>{tenant?.businessName}</Td>
                  <Td>{tenant?.vatNumber}</Td>
                  <Td>{dateFormatter(tenant.activationDate)}</Td>
                  <Td className="row-cell">
                    <div
                      className={` ${
                        tenant.isActive ? "status-label" : "status-label-large"
                      }`}
                    >
                      {tenant.isActive ? "Attivo" : "Non Attivo"}
                    </div>
                    <div
                      className={`status-icon ${
                        tenant?.isActive
                          ? "status-icon-color-green"
                          : "status-icon-color-grey"
                      }`}
                    ></div>
                  </Td>
                  <Td>
                    <div
                      className="icon-container"
                      onClick={() => {
                        props.setIsNew(false);
                        props.setIsOpen(true);
                        props.setTenant(tenant);
                      }}
                    >
                      <FontAwesomeIcon className="icon" icon={faEllipsisVertical} />
                    </div>
                  </Td>
                </Tr>
              );
            })}
        </Tbody>
      )}
    </Table>
  );
}

export default TenantTable;

const Table = styled.table`
  width: 100%;
  margin-top: 4rem;
  border-collapse: collapse;

  .tr-head {
    border: 1px solid transparent;
    border-bottom: solid 1px rgb(157, 166, 173);
  }

  .tr-body {
    border: 1px solid transparent;
    border-bottom: solid 1px rgb(157, 166, 173);

    &:hover {
      border: none;
      border: 1px solid #0090d1;
    }
  }
`;
const Thead = styled.thead`
  width: 100%;
`;

const Tbody = styled.tbody``;

const Tr = styled.tr`
  width: 100%;

  .th-cell-1 {
  }
  .th-cell-2 {
  }
  .th-cell-3 {
  }
  .th-cell-4 {
  }
  .th-cell-6 {
  }
  .th-cell-7 {
    width: 50px;
  }

  .row-cell {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .color-grey {
    background-color: #f2f5f8;
  }
  .table-search {
    border: none;
    width: 98.5%;
  }

  .table-select {
    border: none;
    cursor: pointer;
  }

  .status-icon {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-bottom: 2px;
    margin-left: 8px;
  }

  .status-label {
    width: 40px;
  }

  .status-label-large {
    width: 70px;
  }

  .status-icon-color-green {
    background-color: rgb(9, 130, 42);
  }
  .status-icon-color-grey {
    background-color: rgb(221, 225, 228);
  }

  .position-relative {
    position: relative;
  }

  .search-icon {
    position: absolute;
    right: 1rem;
    top: 0.8rem;
    color: #0090d1;
  }

  .icon-container {
    width: 30px;
    height: 30px;
    background-color: transparent;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 5px;
  }
  .icon-container:hover {
    background-color: #f2f5f8;
    cursor: pointer;
  }

  .icon {
    color: #0090d1;
  }

  .checkbox {
    margin-left: 0.5rem;
  }

  .padding-left-025 {
    padding-left: 0.25rem;
  }
`;

const Th = styled.th`
  color: #005075;
  font-weight: 500;
  height: 2.5rem;
  cursor: pointer;
  text-align: left;
  padding-right: 0.5rem;
  padding-left: 0.25rem;
`;

const Td = styled.td`
  color: #152935;
  font-size: 0.875rem;
  font-weight: 500;
  padding-left: 0.25rem;
  padding-right: 0.5rem;
  height: 2.5rem;
`;
